var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecoratorImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 42,
    viewBox: "0 0 178 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00088 17.446C-1.4327 22.3328 8.01685 23.4351 11.9433 26.1457C18.5531 30.7068 27.0054 33.626 36.0463 35.8751C55.129 40.6293 75.6394 42.4626 97.789 40.5793C113.598 39.2338 128.99 35.7293 143.364 28.819C155.926 22.7787 166.55 15.4012 174.875 6.57568C175.734 5.66315 176.465 4.70098 177.13 3.73658C177.535 3.1475 177.874 2.48487 177.905 1.89731C177.931 1.33728 178 0.499966 177.31 0.303019C176.62 0.106073 175.543 0.732407 174.859 1.12187C173.981 1.6212 173.28 2.28609 172.556 2.90785C168.833 6.11114 165.206 9.36895 161.395 12.5269C150.33 21.6998 136.782 27.819 121.128 31.3456C107.093 34.5104 93.282 35.7362 79.682 35.2743C63.2101 34.7153 47.7213 32.6062 33.9074 27.7652C25.3146 24.7539 12.3969 15.5545 12.3969 15.5545C12.3969 15.5545 11.8605 15.0398 11.4752 14.7628C8.047 12.2975 2.88317 13.6662 1.00088 17.446Z",
    fill: "#005490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoratorImage);
export default __webpack_public_path__ + "static/media/decorator-image.1a80a6d0c55182163065a77f88b4fc13.svg";
export { ForwardRef as ReactComponent };